import { render, staticRenderFns } from "./UserEditPermission.vue?vue&type=template&id=4023045b&"
import script from "./UserEditPermission.vue?vue&type=script&lang=js&"
export * from "./UserEditPermission.vue?vue&type=script&lang=js&"
import style0 from "./UserEditPermission.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports